import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditKitchenStaffReady} from '../redux/kitchen_staffs'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'



import {Employees,Workstation,Kitchens} from '../../../common/DropDowns/index'
//import * as Helpers from '../../../common/helpers'

class AddEditKitchenStaff extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",
        editFlag:false,

        kitchenStaffData:{},

        employeeId: "",
        kitchenStaffGroup: "",
        kitchenId: "",

        employeeIdErrorText: false,
        employeeIdErrorData: '',


        kitchenIdErrorText: false,
        kitchenIdErrorData: '',

        kitchenStaffGroupErrorText: false,
        kitchenStaffGroupErrorData: '',

        statusErrorText: false,
        statusGroupErrorData: '',

        subTitle: Constants.ADD_KITCHEN_STAFF

    }

    this.isComponentStillMounted = true

    this.employeeIdComponent = null
    this.employeeIdSection = null

    this.kitchenStaffGroupComponent = null
    this.kitchenStaffGroupSection = null

    this.kitchenIdComponent = null
    this.kitchenIdSection = null

    this.statusCodeComponent = null
    this.statusCodeSection = null

    }

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(addEditKitchenStaffReady(false))

    if (this.props.kitchen_staffs && this.props.kitchen_staffs.kitchenStaffSelectedId && this.props.kitchen_staffs.kitchenStaffSelectedId !== null) {
        this.props.dispatch(headerDataUpdate(Constants.EDIT_KITCHEN_STAFF))
        this.setState({
            subTitle: "Edit Kitchen Staff",
            editFlag:true
        })
    } else {
        this.props.dispatch(headerDataUpdate(Constants.ADD_KITCHEN_STAFF))
        this.setState({
            subTitle: "Add Kitchen Staff"
        })
    }
    this.props.dispatch(subHeaderDataUpdate())

    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()


    if (this.props.kitchen_staffs && this.props.kitchen_staffs.kitchenStaffSelectedId && this.props.kitchen_staffs.kitchenStaffSelectedId !== null) {
        this.getKitchenStaffById(this.props.kitchen_staffs.kitchenStaffSelectedId)
    }else{

    this.props.dispatch(addEditKitchenStaffReady(true))
    }
}

componentDidMount() {

        this.employeeIdSection = ReactDOM.findDOMNode(this.refs.employeeIdSection)

        this.kitchenStaffGroupSection = ReactDOM.findDOMNode(this.refs.kitchenStaffGroupSection)

        this.kitchenIdSection = ReactDOM.findDOMNode(this.refs.kitchenIdSection)

        this.statusSection = ReactDOM.findDOMNode(this.refs.statusSection)


}

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 100) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}


 employeeChange = (data) => {
    this.employeeIdComponent.value=data.value
        this.setState({
            employeeId :data.value,
            employeeIdErrorText: false,
            employeeIdErrorData: ''
        })
        this.employeeIdSection.className= this.employeeIdSection.className.replace(" has-error", "")
    }


kitchenChange = (data) => {
    this.kitchenIdComponent.value=data.value
        this.setState({
            kitchenId :data.value,
            kitchenIdErrorText: false,
            kitchenIdErrorData: ''
        })
        this.kitchenIdSection.className= this.kitchenIdSection.className.replace(" has-error", "")
    }






     workstationChange= (data) => {
    
        this.kitchenStaffGroupComponent.value=data.value
    
        this.setState({
            kitchenStaffGroup :data.value,
            kitchenStaffGroupErrorText: false,
            kitchenStaffGroupErrorData: ''
        })
            
        this.kitchenStaffGroupSection.className= this.kitchenStaffGroupSection.className.replace(" has-error", "")
    }



onSaveClick = () => {

    this.props.dispatch(addEditKitchenStaffReady(false))
    let data = {}

    if(this.state.editFlag){

         let kitchenStaffGroupObject = this.mandateValidation("kitchenStaffGroup", Constants.FORM_SELECT)
        if (kitchenStaffGroupObject.status) {
            data.work_station_id = this.kitchenStaffGroupComponent.value
        } else {
            this.props.dispatch(addEditKitchenStaffReady(true))
            return
        }


    }else{

        let employeeIdObject = this.mandateValidation("employeeId", Constants.FORM_INPUT)
        if (employeeIdObject.status) {
            data.employee_id = this.employeeIdComponent.value
        } else {

             this.props.dispatch(addEditKitchenStaffReady(true))
            return
        }


        let kitchenIdObject = this.mandateValidation("kitchenId", Constants.FORM_INPUT)
        if (kitchenIdObject.status) {
            data.kitchen_id = this.kitchenIdComponent.value
        } else {
            this.props.dispatch(addEditKitchenStaffReady(true))
            return
        }

        let kitchenStaffGroupObject = this.mandateValidation("kitchenStaffGroup", Constants.FORM_SELECT)
        if (kitchenStaffGroupObject.status) {
            data.work_station_id = this.kitchenStaffGroupComponent.value
        } else {
            this.props.dispatch(addEditKitchenStaffReady(true))
            return
        }



    }


    let apiPayloadData=data;



    if(this.state.editFlag){

        apiService.editKitchenStaff(apiPayloadData,this.state.kitchenStaffData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditKitchenStaffReady(true))
                        this.props.history.push("/dashboard/kitchenStaffs/list")
                    } else {

                        this.props.dispatch(addEditKitchenStaffReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditKitchenStaffReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }else{

    apiService.addKitchenStaff(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditKitchenStaffReady(true))
                        this.props.history.push("/dashboard/kitchenStaffs/list")
                    } else {

                        this.props.dispatch(addEditKitchenStaffReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditKitchenStaffReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }


}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}


getKitchenStaffById = (id) => {
    apiService.getKitchenStaffById(id)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {

                if (responseData && responseData.data) {                   
                    this.setState({
                        kitchenStaffData: responseData.data,
                        kitchenStaffGroup:responseData.data.work_station_id     
                    })

                    if (this.isComponentStillMounted) {
                        this.kitchenStaffGroupComponent.value=responseData.data.work_station_id

                        }
                    this.props.dispatch(addEditKitchenStaffReady(true))             

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditKitchenStaffReady(true))
        })
}




 kitchenStaffGroupChange = (data) => {
    this.kitchenStaffGroupComponent.value=data.value
        this.setState({
            kitchenStaffGroup :data.value,
            kitchenStaffGroupErrorText: false,
            kitchenStaffGroupErrorData: ''
        })
        this.kitchenStaffGroupSection.className= this.kitchenStaffGroupSection.className.replace(" has-error", "")
    }





 entityStatusChange= (data) => {
    
        this.statusComponent.value=data.value
    
        this.setState({
            status :data.value,
            statusErrorText: false,
            statusErrorData: ''
        })
            
        this.statusSection.className= this.statusSection.className.replace(" has-error", "")
    }



    







    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>


                                             {(() => {
                                        if(!this.state.editFlag){
                                            return (
                                                <div className="row">
                                        
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                           <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.employeeIdSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Employee *</label>
                                                    <div className="col-sm-9" ref={el => this.employeeIdComponent = el}>
                                                        
                                                         <Employees type="notmapped_ks_list" employeeChange={this.employeeChange} selectedValue={this.state.employeeId} />

                                                        <span className="help-block"style={{display: this.state.employeeIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.employeeIdErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                          <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.kitchenIdSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Kitchen *</label>
                                                    <div className="col-sm-9" ref={el => this.kitchenIdComponent = el}>
                                                        
                                                         <Kitchens kitchenChange={this.kitchenChange} selectedValue={this.state.kitchenId} />

                                                        <span className="help-block"style={{display: this.state.kitchenIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.kitchenIdErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>

                                            </div>
                                        
                                         )
                                        }else{
                                            return(
                                        <div className="row">
                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-6 col-sm-12 col-xs-12">
                                                  <div className="form-group">
                                                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Employee :</label>
                                                     <div className="col-sm-9">
                                                        {(() => {
                                                            if(this.state.kitchenStaffData.employee && this.state.kitchenStaffData.employee.name!=="" && this.state.kitchenStaffData.employee.name!==undefined){
                                                                return(
                                                                    <p>{this.state.kitchenStaffData.employee.name} - {this.state.kitchenStaffData.employee.code}</p>
                                                                )
                                                            }else{
                                                                return(
                                                                    <p>NA</p>
                                                                )
                                                            }
                                                        })()}                                         
                                                     </div>
                                                  </div>
                                               </div>   
                                           </div>


                                           <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-6 col-sm-12 col-xs-12">
                                                  <div className="form-group">
                                                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Designation :</label>
                                                     <div className="col-sm-9">
                                                        {(() => {
                                                            if(this.state.kitchenStaffData.employee && this.state.kitchenStaffData.employee.designation && this.state.kitchenStaffData.employee.designation.name!=="" && this.state.kitchenStaffData.employee.designation.name!==undefined){
                                                                return(
                                                                    <p>{this.state.kitchenStaffData.employee.designation.name}</p>
                                                                )
                                                            }else{
                                                                return(
                                                                    <p>NA</p>
                                                                )
                                                            }
                                                        })()}                                         
                                                     </div>
                                                  </div>
                                               </div>   
                                           </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-6 col-sm-12 col-xs-12">
                                                  <div className="form-group">
                                                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Kitchen :</label>
                                                     <div className="col-sm-9">
                                                        {(() => {
                                                            if(this.state.kitchenStaffData.kitchen && this.state.kitchenStaffData.kitchen.name!=="" && this.state.kitchenStaffData.kitchen.name!==undefined){
                                                                return(
                                                                    <p>{this.state.kitchenStaffData.kitchen.name}</p>
                                                                )
                                                            }else{
                                                                return(
                                                                    <p>NA</p>
                                                                )
                                                            }
                                                        })()}                                         
                                                     </div>
                                                  </div>
                                               </div>   
                                           </div>


                                        </div>
                                            )
                                        }


                                })()}


                                        <div className="row">

                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                         <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.kitchenStaffGroupSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Work Station *</label>
                                                    <div className="col-sm-9" ref={el => this.kitchenStaffGroupComponent = el}>
                                                        
                                                         <Workstation type="Kitchen" workstationChange={this.workstationChange} selectedValue={this.state.kitchenStaffGroup} />

                                                        <span className="help-block"style={{display: this.state.kitchenStaffGroupErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.kitchenStaffGroupErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                        </div>

                                       

                                            
                                           



                                        
                                            
                                                </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            </div>
                                        </div>

                                    </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        kitchen_staffs: state.kitchen_staffs,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditKitchenStaff))


// WEBPACK FOOTER //
// ./src/modules/Kitchen Staffs/Components/AddEditKitchenStaff.js